import buildingsYaml from './data/base/buildings.yaml?raw';
import resourcesYaml from './data/base/resources.yaml?raw';
import rulesYaml from './data/base/rules.yaml?raw';
import unitsYaml from './data/base/units.yaml?raw';
import { loadRuleSet } from './load';
import type { RuleSet } from './schema';

const baseRuleSet: RuleSet = loadRuleSet({
  resources: resourcesYaml,
  units: unitsYaml,
  buildings: buildingsYaml,
  rules: rulesYaml,
});

export { baseRuleSet };
